import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-bottom-icon',
  imports: [],
  templateUrl: './chevron-bottom-icon.html',
  styleUrl: './chevron-bottom-icon.scss',
})
export class ChevronBottomIcon {

}
